import { useContext, useEffect, useMemo } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { LayoutContext, Wizard, WizardProps } from '@/_shared/components';
import { ImportCompanyData } from '../components/ImportCompanyData';
import { getEmployeesImportsOverviewCall } from '../state';

export const PeopleImportScreen = () => {
  const t = useTranslations('people.importCompanyData.wizard');
  const { setLayout } = useContext(LayoutContext);

  const { pendingReviewImport } = getEmployeesImportsOverviewCall.hook();

  const wizardSteps: WizardProps['stepsConfig'] = useMemo(() => {
    const editImportStep: WizardProps['stepsConfig'][0] = {
      label: t('verifyData.title'),
      steps: [
        {
          label: 'Dati aziendali',
          // eslint-disable-next-line react/no-unstable-nested-components
          component: ({ wizardNavigationButton }) => (
            <ImportCompanyData.VerifyData wizardNavigationButton={wizardNavigationButton} />
          ),
          nextButtonLabel: t('verifyData.confirm'),
          previousButtonLabel: t('verifyData.previous'),
          showNextButton: false,
          showPreviousButtonBeforeProgressBar: true,
          showPreviousButton: !pendingReviewImport?.pendingJob,
          forceShowPreviousButton: !!pendingReviewImport?.pendingJob,
        },
      ],
    };

    if (pendingReviewImport?.pendingJob) {
      return [editImportStep];
    }

    return [
      {
        label: t('setData.title'),
        steps: [
          {
            label: 'Upload',
            // eslint-disable-next-line react/no-unstable-nested-components
            component: ({ wizardNavigationButton }) => (
              <ImportCompanyData.SetData wizardNavigationButton={wizardNavigationButton} />
            ),
            showSkipButton: false,
            showNextButton: false,
            forceShowPreviousButton: true,
            showPreviousButtonBeforeProgressBar: true,
            previousButtonLabel: t('setData.previous'),
            nextButtonLabel: t('setData.confirm'),
          },
        ],
      },
      editImportStep,
    ];
  }, [pendingReviewImport?.pendingJob, t]);

  useEffect(() => {
    setLayout({ title: 'people' });
  }, [setLayout, t]);

  return <Wizard stepsConfig={wizardSteps} />;
};
